import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'FreeImageMathSolver - Solve Math Problems Instantly with AI',
    description = 'Upload a photo of any math problem and get instant step-by-step solutions. Free AI-powered math solver supporting Algebra, Calculus, Geometry, Trigonometry and more. No signup required.',
    keywords = 'math solver, AI math help, step-by-step solutions, math problem solver, algebra solver, calculus solver, geometry solver, trigonometry solver, free math help, math homework help, photo math solver, image math solver',
    ogImage = '/og-image.jpg',
    canonical = ''
}) => {
    const siteUrl = 'https://freeimagemathsolver.online';
    const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Canonical URL */}
            <link rel="canonical" href={fullCanonical} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={fullCanonical} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${siteUrl}${ogImage}`} />
            <meta property="og:site_name" content="FreeImageMathSolver" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullCanonical} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={`${siteUrl}${ogImage}`} />

            {/* Additional Meta Tags */}
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />
            <meta name="author" content="FreeImageMathSolver" />
        </Helmet>
    );
};

export default SEO;
